module.exports = __webpack_public_path__ + "b6ed4ed68fe01e520726a76f541b751b.svg";